import { customEmailConstants } from '../../_constants';
import { customEmailService } from '../../_services';

export const sendCustomMailAction = {
    sendCustomMailHandler
};

function sendCustomMailHandler(data,callback) {
    return dispatch => {
        dispatch(request());
        customEmailService.sendCustomMailHandler(data)
            .then(
                sendCustomMail => {
                    dispatch(success(sendCustomMail));
                    callback()
                },
                error => {
                    dispatch(failure(error));
                }
            );
    };

    function request() { return { type: customEmailConstants.REQUEST_CUSTOM_MAIL } }
    function success(sendCustomMail) { return { type: customEmailConstants.RECIEVE_CUSTOM_MAIL, sendCustomMail } }
    function failure(error) { return { type: customEmailConstants.ERROR_CUSTOM_MAIL, error } }
}



// WEBPACK FOOTER //
// ./src/_actions/CustomEmails/sendCustomMail.action.js